import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHelmet from '../components/shared/PageHelmet';
import HomeOneHeader from './Home/HomeOneHeader/HomeOneHeader';
import Footer from '../components/shared/Footer';

// Página 404. Los textos van aquí (ES/EN) y no en i18n.js: las claves error_404_* nunca se
// dieron de alta y la página enseñaba los nombres de las claves. Sin cabecera de página: el
// título gigante duplicaba el «404».
const T = {
  es: {
    meta: 'Página no encontrada',
    title: 'No encontramos esta página',
    text: 'Puede que la dirección esté mal escrita o que la página se haya movido.',
    path: 'Dirección',
    home: 'Volver al inicio',
    services: 'Ver sistemas',
    contact: 'Contactar',
  },
  en: {
    meta: 'Page not found',
    title: 'We could not find this page',
    text: 'The address may be misspelled or the page may have moved.',
    path: 'Address',
    home: 'Back to home',
    services: 'See systems',
    contact: 'Contact us',
  },
};

const CSS = `
.e404{padding:150px 16px 90px;text-align:center}
.e404-code{font-size:clamp(64px,10vw,104px);font-weight:700;line-height:1;color:#7c74ff;letter-spacing:-.02em;margin:0 0 14px}
.e404 h1{font-size:clamp(22px,2.6vw,30px);margin:0 0 10px;color:#10131c}
.e404 p{color:#6b7180;font-size:16px;max-width:520px;margin:0 auto 14px;line-height:1.5}
.e404-path{display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:13px;color:#6b7180;background:#f5f6fb;border:1px solid rgba(120,128,150,.22);border-radius:10px;padding:6px 12px;margin:0 0 26px}
.e404-actions{display:flex;flex-wrap:wrap;justify-content:center;gap:10px}
.e404-actions a{padding:11px 18px;border-radius:10px;border:1px solid #7c74ff;color:#7c74ff;font-weight:600;font-size:15px;text-decoration:none}
.e404-actions a.main{background:#7c74ff;color:#fff}
`;

const Error404 = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const t = T[(i18n.language || 'es').startsWith('en') ? 'en' : 'es'];

  return (
    <>
      <PageHelmet pageTitle={t.meta} noindex />
      <style>{CSS}</style>
      <HomeOneHeader textColor="purple" logoVariant="purple" />

      <section className="e404">
        <div className="e404-code" aria-hidden="true">404</div>
        <h1>{t.title}</h1>
        <p>{t.text}</p>
        <div className="e404-path">{t.path}: {pathname}</div>
        <div className="e404-actions">
          <Link to="/" className="main">{t.home}</Link>
          <Link to="/services">{t.services}</Link>
          <Link to="/contact">{t.contact}</Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Error404;
